"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pick.title': 'Onboarding de Empleado',
    'onboarding.pick.description': '¿A quién desea asignar nuevas responsabilidades en su empresa?',
    'onboarding.pick.loading': 'Cargando profesiones...',
};
